export const GetTasksSUCCESS="getTasks/Success";
export const GetTasksAppendSUCCESS="getTasks/AppendSuccess";
export const GetTasksLOADING="getTasks/Loading";
export const GetTasksLOADINGMORE="getTasks/LoadingMore";
export const GetTasksERROR="getTasks/Error";
export const PostTasksSUCCESS="postTasks/Success";
export const UpdateTasksSUCCESS="UpdateTasks/Success";
export const DeleteTasksSUCCESS="deleteTasks/Success";
export const start="start";

